module.exports = require("./fo-DK");